<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">รายการคูปอง</h1>
                    <p class="text-white pb-3 px-3">รายการคูปองส่วนลดที่ได้รับ</p>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-7">
                                    <b-form-group id="input-group-1" label="ค้นหาวันที่ได้รับ (วันเริ่มต้น - วันสุดท้าย)"
                                        label-for="input-1" class="mb-0">
                                        <div class="row align-self-center">
                                            <div class="col-lg-5">
                                                <date-range-picker class="w-100" :opens="'center'"
                                                    @start-selection="logEvent('startSelection', $event)"
                                                    @finish-selection="logEvent('finishSelection', $event)"
                                                    :min-date="minDate" :max-date="maxDate" :singleDatePicker="false"
                                                    :appendToBody="true" :ranges="false" :closeOnEsc="false"
                                                    :autoApply="true" :locale-data="{ format: 'dd-mm-yyyy' }"
                                                    v-model="filters">
                                                </date-range-picker>
                                            </div>

                                            <div class="col-lg" v-if="isShowSpecailColumn">
                                                <v-select
                                                    :options="shops"
                                                    class="custom-dropdown"
                                                    placeholder="ค้นหาร้านค้า"
                                                    label="name"
                                                    taggable
                                                    v-model="selectedShop"
                                                    :reduce="selectedShop => selectedShop.id"
                                                >
                                                    <template slot="option" slot-scope="option">
                                                            {{ (option.shop_code || '') + ' ('+option.name+')' }}
                                                    </template>
                                                </v-select>
                                            </div>

                                            <div class="col-lg-2">
                                                <button class="btn btn-info btn-sm-res" @click="fetchCoupons()">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div>
                            <b-table 
                                class="scroll-bar-pop"
                                empty-text="ไม่มีรายละเอียดคูปองส่วนลด"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                :items="coupons"
                                :fields="coupon_table_fields"
                                :busy="busy"
                                show-empty
                                responsive
                            >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>

                                <template slot="index" slot-scope="data">
                                    {{ (pagination.perPage * (pagination.currentPage - 1)) + data.index + 1 }}
                                </template>
                                <template v-if="isShowSpecailColumn" slot="shop_code" slot-scope="row">
                                    {{ row.item.shop_code }}
                                </template>
                                <template slot="created_at" slot-scope="row">
                                    {{ row.item.created_at | dateFormat() }}
                                </template>
                                <template slot="expired_at" slot-scope="row">
                                    {{ row.item.expired_at | dateFormat() }}
                                </template>
                                <template slot="coupon_code" slot-scope="row">
                                    {{ row.item.coupon_code }}
                                </template>
                                <template slot="total_amount" slot-scope="row">
                                    {{ row.item.total_amount }}
                                </template>
                                <template slot="balance_amount" slot-scope="row">
                                    {{ row.item.balance_amount }}
                                </template>
                                <template slot="status" slot-scope="row">
                                    <span v-if="
                                        row.item.campaign_info.state.toLowerCase() === 'live' && 
                                        moment(row.item.expired_at) >= moment() &&
                                        row.item.balance_amount > 0
                                        " 
                                        class="badge badge-primary">
                                        ใช้งานได้
                                    </span>
                                    <span v-else-if="row.item.balance_amount == 0 || moment(row.item.expired_at) < moment()" class="badge badge-danger">
                                        หมดอายุ
                                    </span>
                                    <span v-else class="badge badge-danger">
                                        ไม่สามารถใช้งาน
                                    </span>
                                </template>
                                <template slot="action" slot-scope="row">
                                    <b-button variant="primary" size="sm" @click="onOpenModal(row.item)">รายละเอียด</b-button>
                                </template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="pagination.totalItem" :current-page="pagination.currentPage"
                                    :per-page="pagination.perPage" :value="pagination.currentPage" @input="changePage"
                                    align="right"
                                >
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <b-modal
                v-model="modal.open"
                stacking
                centered
                no-close-on-esc
                no-close-on-backdrop
                hide-footer
                header-class="border-bottom"
                size="lg"
                title="รายละเอียดคูปอง"
                @hidden="onCloseModal"
            >
                <template>
                    <div class="pb-3">
                        <h2 class="font-weight-bold">{{ modal.data.name }}</h2>
                        <small>{{ modal.data.description }}</small>
                    </div>

                    <b-table
                        class="scroll-bar-pop"
                        empty-text="ไม่มีรายละเอียดคูปองส่วนลด"
                        empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                        :items="modal.data.items"
                        :fields="coupon_detail_table_fields"
                        :busy="busy"
                        show-empty
                        responsive
                    >
                        <template slot="index" slot-scope="data">
                            {{ data.index + 1 }}
                        </template>
                        <template slot="courier_code" slot-scope="row">
                            {{ row.item.courier_code }}
                        </template>
                        <template slot="discount_value" slot-scope="row">
                            {{ row.item.discount_value | numFormat('0,0.00') }}
                        </template>
                        <template slot="min_weight" slot-scope="row">
                            {{ row.item.min_weight | numFormat('0,0') }}
                        </template>
                        <template slot="max_weight" slot-scope="row">
                            {{ row.item.max_weight != null ? $options.filters.numFormat(row.item.max_weight, '0,0') : '-' }}
                        </template>
                        <template slot="min_size" slot-scope="row">
                            {{ row.item.min_size != null ? $options.filters.numFormat(row.item.min_size, '0,0') : '-' }}
                        </template>
                        <template slot="max_size" slot-scope="row">
                            {{ row.item.max_size != null ? $options.filters.numFormat(row.item.max_size, '0,0') : '-' }}
                        </template>
                    </b-table>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
import 'moment-timezone/builds/moment-timezone-with-data';

import { dateLimitRanges } from "@/plugins/datePicker.js"
import moment from "moment";
import { fetchCoupons } from '@/axios/coupon.js'

export default {
    data() {
        return {
            busy: false,
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            filters: {
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            shops: [],
            coupons: [],
            pagination: {
                totalPage: 1,
                totalItem: 0,
                currentPage: 1,
                perPage: 20,
            },
            coupon_table_fields: [],
            coupon_detail_table_fields: [
                {
                    key: "index",
                    field: "index",
                    label: "#",
                    sortable: true
                },
                {
                    key: "courier_code",
                    field: "courier_code",
                    label: "ขนส่ง",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "discount_value",
                    field: "discount_value",
                    label: "ส่วนลดมูลค่า (บาท)",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "min_weight",
                    field: "min_weight",
                    label: "น้ำหนักขั้นต่ำ (กรัม)",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "max_weight",
                    field: "max_weight",
                    label: "น้ำหนักสูงสุด (กรัม)",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "min_size",
                    field: "min_size",
                    label: "ขนาดต่ำสุดรวม (ซม.)",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "max_size",
                    field: "max_size",
                    label: "ขนาดสูงสุดรวม (ซม.)",
                    sortable: true,
                    class: "text-center"
                },
            ],
            modal: {
                open: false,
                data: []
            },
            isShowSpecailColumn: false,
            selectedShop: null,
        }
    },
    created() {
        if (
            this.$USER_LOGIN.get().isShippop ||
            this.$USER_LOGIN.get().isSuperAdmin
        ) {
            this.isShowSpecailColumn = true
        }
        
        this.coupon_table_fields = this.tableFields()
    },
    mounted() {
        this.fetchListShop()
        this.fetchCoupons()
    },
    filters: {
        dateFormat(date) {
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
    },
    methods: {
        tableFields() {
            if (
                this.$USER_LOGIN.get().isShippop ||
                this.$USER_LOGIN.get().isSuperAdmin
            ) {
                return [
                    { key: "index", field: "index", label: "#", sortable: true },
                    { key: 'shop_code', field: 'shop_code', label: "รหัสร้านค้า", sortable: true },
                    { key: "created_at", field: "created_at", label: "วันที่ได้รับ", sortable: true, class: "text-center" },
                    { key: "expired_at", field: "expired_at", label: "วันหมดอายุ", sortable: true, class: "text-center" },
                    { key: "coupon_code", field: "coupon_code", label: "รหัสคูปอง", sortable: true, class: "text-center" },
                    { key: "total_amount", field: "total_amount", label: "จำนวน (ใบ)", sortable: true, class: "text-center" },
                    { key: "balance_amount", field: "balance_amount", label: "คงเหลือ (ใบ)", sortable: true, class: "text-center" },
                    { key: "status", field: "status", label: "สถานะ", sortable: true, class: "text-center" },
                    { key: 'action', field: 'action', label: "รายละเอียด", class: "text-center" },
                ]
            }

            return [
                { key: "index", field: "index", label: "#", sortable: true },
                { key: "created_at", field: "created_at", label: "วันที่ได้รับ", sortable: true, class: "text-center" },
                { key: "expired_at", field: "expired_at", label: "วันหมดอายุ", sortable: true, class: "text-center" },
                { key: "coupon_code", field: "coupon_code", label: "รหัสคูปอง", sortable: true, class: "text-center" },
                { key: "total_amount", field: "total_amount", label: "จำนวน (ใบ)", sortable: true, class: "text-center" },
                { key: "balance_amount", field: "balance_amount", label: "คงเหลือ (ใบ)", sortable: true, class: "text-center" },
                { key: "status", field: "status", label: "สถานะ", sortable: true, class: "text-center" },
                { key: 'action', field: 'action', label: "รายละเอียด", class: "text-center" },
            ]
        },
        logEvent(event, date) {
            const { minDate, maxDate } = dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
        onOpenModal(data) {            
            this.modal.data = {
                name: data.campaign_info.name,
                description: data.campaign_info.description,
                items: [...Object.values(data.campaign_info.condition)]
            }
            this.modal.open = true
        },
        onCloseModal() {
            this.modal.open = false
            this.modal.data = {}
        },
        changePage(i) {
            if (this.pagination.currentPage == i) {
                return
            }

            this.pagination.currentPage = i

            this.fetchCoupons()
        },
        async fetchCoupons() {
            this.busy = true
            
            const createdAtStart = moment(this.filters.startDate).format("YYYY-MM-DD")
            const createdAtEnd = moment(this.filters.endDate).format("YYYY-MM-DD")
            
            const filterParmas = {
                created_at_start: createdAtStart,
                created_at_end: createdAtEnd,
                shop_id: this.selectedShop,
                limit: this.pagination.perPage,
                page: this.pagination.currentPage
            }

            await fetchCoupons(filterParmas)
                .then((res) => {
                    this.coupons = [...res.items]
                    this.pagination.totalItem = res.total_item
                    this.pagination.totalPage = res.total_page
                    this.pagination.perPage = res.per_page
                })
                .catch(() => {
                    this.coupons = []
                })
                .finally(() => {
                    this.busy = false
                })
        },
        async fetchListShop() {
            const API_URL = process.env.VUE_APP_API
            this.busy = true

            this.$http.get(API_URL + "/shop/list", {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            })
            .then((res) => {
                if (res.data) {
                    this.shops = res.data.data
                } else {
                    this.shops = []
                }
            })
            .catch(() => {
                this.shops = []
            })
            .finally(() => {
                this.busy = false
            })
        }
    },
}
</script>